import { AxiosRequestConfig } from "axios";

import { axiosInstance } from "../api/axiosConfig";

export const getOrders = async (options: AxiosRequestConfig) => {
  var statusList = "?";

  if (Array.isArray(options.params.order_status)) {
    options.params.order_status.map((status: number) => {
      statusList += `order_status=${status}&`;
    });
    delete options.params.order_status;
  }

  const response = await axiosInstance.get(
    "/trade-engine/orders" + statusList,
    options,
  );

  return response;
};

export const cancelOrder = async (options: AxiosRequestConfig) => {
  return axiosInstance.put("/trade-engine/cancel", null, options);
};

export const syncPortfolios = async (onlyStatus?: boolean) => {
  const data = await axiosInstance.get(`trade-engine/sync-portfolio`, {
    params: { return_only_status: onlyStatus },
  });
  return data;
};
